module.exports = __webpack_public_path__ + "static/media/opc.1aff6be9.webp";